import { createFileRoute } from "@tanstack/react-router";
import { routeOptions } from "@/pages/egenkontrollparm";
import { withAlternates } from "@/lib/route-i18n";

export const Route = createFileRoute("/egenkontrollparm")(withAlternates(routeOptions, "/egenkontrollparm"));
